import React from "react";
import Navigation from "../../form-navigation/Navigation";
import { scrollToTop } from "components/common/services/ValidationService";
import { t } from "components/CentralDataMangement/translation/Translation";
import LabelWithTextAreaField from "components/common/molecules/LabelWithTextAreaField";
import { useFormContext } from "components/CompanyCreation/AdminFiche/context/Context";
import * as CONST from "../../../annotations/AdminFicheConstants";


const Others = () => {
  const { state, dispatch } = useFormContext();

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target as HTMLInputElement;
    dispatch({
      type: CONST.UPDATE_FIELDS,
      template: CONST.OTHERS,
      field: name,
      value: value,
    });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    scrollToTop();
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="row">
        <div className="col-12">
          <div className="form-border" style={{ paddingTop: "3.4vw" }}>
            <LabelWithTextAreaField
              name="extraInfo"
              handleChange={handleChange}
              value={state.others.extraInfo ?? ''}
              label={t("Extra info")}
              rows={5}
            />
          </div>
        </div>
      </div>
      <Navigation />
    </form>
  );
};

export default Others;
